import { render, staticRenderFns } from "./CategoryMaster.vue?vue&type=template&id=4e1596a0&scoped=true"
import script from "./CategoryMaster.vue?vue&type=script&lang=js"
export * from "./CategoryMaster.vue?vue&type=script&lang=js"
import style0 from "./CategoryMaster.vue?vue&type=style&index=0&id=4e1596a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1596a0",
  null
  
)

export default component.exports